import { useSearchParams } from "react-router";

import { Button, Icon, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolParentBlock, MessageToolParentBlocksData } from "@virtual-brain-lib/types";

import { ToolCard } from "../core";

function BlockRow({
	block,
	index,
	onBlockClick,
}: {
	readonly block: MessageToolParentBlock;
	readonly index: number;
	readonly onBlockClick: (blockId: string) => void;
}) {
	return (
		<div className="flex flex-col gap-1 rounded px-1.5 py-1">
			<div className="flex items-center gap-1.5">
				<Icon name="stack" />
				<Span variant="body-xs" color="default" className="min-w-0 truncate">
					{block.name}
				</Span>
				<Button
					size="xs"
					variant="outline"
					onClick={() => {
						onBlockClick(block.id);
					}}
				>
					block {index + 1}
				</Button>
			</div>
		</div>
	);
}

export function ToolCardParentBlocks({
	state,
	className,
}: {
	readonly state: MessageToolParentBlocksData;
	readonly className?: string;
}) {
	const { blocks } = state;
	const [, setSearchParams] = useSearchParams();

	if (!blocks.length) return null;

	const count = blocks.length;

	const handleBlockClick = (blockId: string) => {
		setSearchParams(new URLSearchParams({ blockId }));
	};

	return (
		<ToolCard
			className={className}
			icon="stack"
			title="Previous blocks"
			statusText={`${count} block${count > 1 ? "s" : ""} used`}
			status="processed"
		>
			<div className="flex flex-col">
				{blocks.map((block, index) => (
					<BlockRow
						key={block.id}
						block={block}
						index={index}
						onBlockClick={handleBlockClick}
					/>
				))}
			</div>
		</ToolCard>
	);
}
